import { buildUrl } from 'embed/utils'
import { fetch } from 'whatwg-fetch'

export class IpAddress {
  public async get(): Promise<string> {
    const url = buildUrl('https://api.ipify.org', { format: 'json' })
    const request = await fetch(url.href, {
      method: 'GET',
    })
    const response = await request.json()
    return response.ip
  }
}

export default new IpAddress()
